import React, { useEffect } from "react";

import { ModalContent, ModalOverlay, ModalWrapper } from "./elements";

const Modal = ({ open, onClose, children, position, hasOverflow, isPaymentPage }) => {
	useEffect(() => {
		if (open) {
			document.body.style.overflow = "hidden";
		} else {
			document.body.style.overflow = "unset";
		}

		return () => {
			document.body.style.overflow = "unset";
		};
	}, [open]);

	return (
		<ModalWrapper
			position={position}
			open={open}>
			<ModalOverlay onClick={onClose} />
			<ModalContent
				isPaymentPage={isPaymentPage}
				hasOverflow={hasOverflow}>
				<div className="modal-item">{children}</div>
			</ModalContent>
		</ModalWrapper>
	);
};

export default Modal;
